import type { ReactNode } from "react";
import type { AnnouncementEvent } from "@/features/announce/mediators/announcementEvents";
import { ComponentScope } from "@/shared/ui/component-hierarchy/ComponentScope";
import { useComponentNode } from "@/shared/ui/component-hierarchy/hooks";

interface AnnouncementItemPresenterProps {
  readonly children: (emit: (event: AnnouncementEvent) => void) => ReactNode;
}

/** Creates the item node from which selection events bubble to its page or modal. */
export function AnnouncementItemPresenter({
  children,
}: AnnouncementItemPresenterProps): ReactNode {
  const node = useComponentNode();
  return (
    <ComponentScope node={node}>
      {children((event: AnnouncementEvent): void => {
        node.dispatch(event);
      })}
    </ComponentScope>
  );
}
